export default "__VITE_ASSET__Vssro2aH__"